import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

const Documents = ({ ...props }) => {
  Documents.propTypes = {
    row: PropTypes.number,
    opportunity: PropTypes.object,
    referral: PropTypes.object,
    property: PropTypes.object,
    documents: PropTypes.array,
    userprofile: PropTypes.object,
    showDocumentModal: PropTypes.func.isRequired,
    showReasonModal: PropTypes.func,
    showDocInModal: PropTypes.bool.isRequired,
    additionalDocuments: PropTypes.array,
    markOpportunityDocumentRead: PropTypes.func.isRequired
  };

  function checkImageOrText (url) {
    const allowedExtensions = ['.gif', '.txt', '.jpeg', '.jpg', '.png'];
    for (const extension of allowedExtensions) {
      if (url != null && url.toLowerCase().endsWith(extension)) {
        return true;
      }
    }
    return false;
  }

  function getStatusClass (status) {
    switch ((status || '').toLowerCase().trim()) {
      case 'ready for review':
        return 'status-ready-for-review';
      case 'rejected':
        return 'status-rejected';
      case 'approved':
        return 'status-approved';
      default:
        return '';
    }
  }

  const leadSource = _.get(props, 'referral.leadSources[0].leadSource', '');
  const oppAddDocs = (props.additionalDocuments || []).filter(ad => _.get(ad, 'opportunityId', undefined) === _.get(props, 'opportunity.opportunityKey', null));
  return (
    <React.Fragment>
      <div>
        <div className='d-flex document-row document-row-header'>
          <small className='doc-col-name'>
            DOCUMENT NAME
          </small>
          <small className='doc-col-date'>
            UPLOAD DATE
          </small>
          <small className='doc-col-status'>
            STATUS
          </small>
        </div>
        {
          props.documents && props.documents.length > 0 && props.documents
            .map((documentDetails, index) => {
              return (
                <div className='d-flex document-row' key={`document${index}`}>
                  <div className='doc-col-name text-truncate'>
                    {
                      (checkImageOrText(documentDetails.documentURL)) ? (
                        <a onClick={() => {
                          props.showDocumentModal(documentDetails.documentURL, leadSource);
                        }}>
                          {`${documentDetails.documentName.substr(0, 19)}${(documentDetails.documentName.length > 20) ? '...' : ''}`}
                        </a>
                      ) : (
                        <a href={documentDetails.documentURL} download>
                          {`${documentDetails.documentName.substr(0, 19)}${(documentDetails.documentName.length > 20) ? '...' : ''}`}
                        </a>
                      )
                    }
                  </div>
                  <div className='doc-col-date'>
                    {
                      documentDetails.uploadDate && moment(documentDetails.uploadDate).utc(false).format('M/D/YY')
                    }
                  </div>
                  <div className='doc-col-status'>
                    {
                      documentDetails.reviewReason ? (
                        <a
                          className={`has-review-reason ${getStatusClass(documentDetails.reviewStatus)}`}
                          role='button'
                          onClick={() => props.showReasonModal(documentDetails.documentName, documentDetails.reviewStatus, documentDetails.reviewReason)}
                        >
                          {documentDetails.reviewStatus || ''}
                        </a>
                      ) : (
                        <span className={getStatusClass(documentDetails.reviewStatus)}>
                          {documentDetails.reviewStatus || ''}
                        </span>
                      )
                    }
                  </div>
                </div>
              );
            })
        }
        {
          oppAddDocs && oppAddDocs.length > 0 &&
            oppAddDocs.map((documentMapping, index) => {
              const documentName = _.get(documentMapping, 'documentAlias', _.get(documentMapping, 'document.name', 'Document'));
              return <div className='d-flex document-row' key={`document${index}`}>
                <div className='doc-col-name text-truncate'>
                  {
                    props.showDocInModal ? <a onClick={() => {
                      props.markOpportunityDocumentRead(documentMapping);
                      props.showDocumentModal(documentMapping.documentURL, leadSource);
                    }}>
                      {`${documentName}`}
                    </a>
                      : <a onClick={() => {
                        props.markOpportunityDocumentRead(documentMapping);
                      }} href={documentMapping.documentURL} download>
                        {`${documentName}`}
                      </a>
                  }
                </div>
              </div>;
            })
        }
      </div>
    </React.Fragment>
  );
};
export default Documents;
